<template>
  <v-row>
    <v-col class="pl-0 ml-n2">
      <v-autocomplete
        v-model="selectedItems"
        item-text="name"
        item-value="id"
        :items="items"
        label="Sous-thématique"
        :menu-props="{ maxHeight: '400', zIndex: 13 }"
        multiple
        outlined
        dense
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SubThematicFilter",
  data() {
    return {};
  },
  async created() {
    await this.$store.dispatch("audience/getAcpmSubThematicList");
  },
  computed: {
    items() {
      return this.$store.getters["audience/getAcpmSubThematicList"];
    },
    selectedItems: {
      get() {
        return this.$store.getters["audience/getAcpmSubThematics"];
      },
      set(ids) {
        this.$store.dispatch("audience/updateAcpmSubThematics", ids);
      },
    },
  },
};
</script>

<style scoped></style>
